import { useEffect, useState } from "react";
import { useNavigation } from "react-router";
import "./HotelPrebookProgress.css";

const LABELS = {
  en: {
    title: "Confirming hotel availability",
    detail: "We are checking the current room price with the hotel provider.",
  },
  lv: {
    title: "Pārbaudām viesnīcas pieejamību",
    detail: "Mēs pārbaudām aktuālo numura cenu pie viesnīcas piegādātāja.",
  },
  ru: {
    title: "Проверяем доступность отеля",
    detail: "Мы уточняем актуальную стоимость номера у поставщика отеля.",
  },
};

function selectedLanguage() {
  const language = new URLSearchParams(window.location.search).get("lang")?.toLowerCase();
  return LABELS[language] ? language : "en";
}

export function HotelPrebookProgress({ forceVisible = false }) {
  const navigation = useNavigation();
  const targetPath = navigation.location?.pathname || window.location.pathname;
  const visible =
    forceVisible ||
    (navigation.state === "loading" && targetPath.startsWith("/search/hotels/preview/"));
  const [progress, setProgress] = useState(8);

  useEffect(() => {
    if (!visible) {
      setProgress(8);
      return undefined;
    }

    const timer = window.setInterval(() => {
      setProgress((current) => Math.min(92, current + Math.max(1, Math.ceil((92 - current) * 0.08))));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [visible]);

  if (!visible) return null;

  const label = LABELS[selectedLanguage()];
  return (
    <div className="hotel-prebook-progress-backdrop" data-testid="hotel-prebook-progress">
      <section className="hotel-prebook-progress-card" aria-live="polite" aria-busy="true">
        <h2>{label.title}</h2>
        <p>{label.detail}</p>
        <div
          className="hotel-prebook-progress-track"
          role="progressbar"
          aria-label={label.title}
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow={progress}>
          <div className="hotel-prebook-progress-value" style={{ width: `${progress}%` }} />
        </div>
        <strong className="hotel-prebook-progress-percent">{progress}%</strong>
      </section>
    </div>
  );
}
